import { Routes } from "~/routes";
import { Link } from "~/components/Link";
import { faBook, faCog, faPlug } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "~/lib/utils";
import { Anchor } from "~/components/Anchor";
import { FeatureNames } from "~/modules/feature_flag/flags";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";
import { RWA_URLS } from "~/consts";
import { OauthUserEvents } from "~/modules/analytics/events/oauth";

// // // //

enum NavIcons {
    mcp = "mcp",
    settings = "settings",
    docs = "docs",
}

const mapIconToFontAwesomeIcon = (icon: NavIcons) => {
    switch (icon) {
        case NavIcons.mcp:
            return faPlug;
        case NavIcons.settings:
            return faCog;
        case NavIcons.docs:
            return faBook;
    }
};

// ENHANCEMENT - add FeatureFlag / Access Control here
export const tabs: Array<{
    id: "mcp" | "settings" | "docs";
    name: string;
    url: string;
    icon: NavIcons;
    analyticsLabel: string;
    featureFlag?: FeatureNames;
    external?: boolean;
}> = [
    {
        name: "MCP",
        url: Routes.toolsMcp,
        id: "mcp",
        icon: NavIcons.mcp,
        analyticsLabel: OauthUserEvents.ClickMcpNavItem,
    },
    {
        name: "Settings",
        url: Routes.oauthClients,
        id: "settings",
        icon: NavIcons.settings,
        analyticsLabel: OauthUserEvents.ClickSettingsNavItem,
    },
    {
        name: "Docs",
        url: RWA_URLS.docsMcp,
        id: "docs",
        icon: NavIcons.docs,
        analyticsLabel: OauthUserEvents.ReadMcpSetupDocs,
        external: true,
    },
];

// // // //

export function McpNav(props: {
    page?: "mcp" | "settings";
    children: React.ReactNode;
}) {
    const { page = "endpoints" } = props;

    return (
        <div className="w-full flex justify-center">
            <div className="w-full flex flex-col px-0">
                <main className="flex-1">
                    <div className="relative w-full max-w-7xl">
                        <div className="pb-8">
                            <div className="block">
                                <div className="border-b flex items-center gap-8 relative">
                                    <div className="flex-1">
                                        <nav className="-mb-px flex space-x-8 items-center">
                                            {tabs.map((tab) => {
                                                const linkClassName = cn(
                                                    "whitespace-nowrap py-4 px-1 border-b-2 text-sm select-none",
                                                    {
                                                        "border-primary text-primary":
                                                            tab.id === page,
                                                        "border-transparent text-muted-foreground hover:border-muted-foreground hover:text-muted-foreground-hover":
                                                            tab.id !== page,
                                                    },
                                                );

                                                const linkContent = (
                                                    <>
                                                        <FontAwesomeIcon
                                                            icon={mapIconToFontAwesomeIcon(
                                                                tab.icon,
                                                            )}
                                                            className="h-4 w-4 mr-2"
                                                        />
                                                        {tab.name}
                                                    </>
                                                );

                                                if (tab.external) {
                                                    return (
                                                        <FeatureFlag
                                                            key={tab.id}
                                                            feature={
                                                                tab.featureFlag
                                                            }
                                                        >
                                                            <Anchor
                                                                key={tab.id}
                                                                href={tab.url}
                                                                openInNewTab
                                                                analyticsLabel={
                                                                    tab.analyticsLabel
                                                                }
                                                                className={
                                                                    linkClassName
                                                                }
                                                            >
                                                                {linkContent}
                                                            </Anchor>
                                                        </FeatureFlag>
                                                    );
                                                }

                                                return (
                                                    <FeatureFlag
                                                        key={tab.id}
                                                        feature={
                                                            tab.featureFlag
                                                        }
                                                    >
                                                        <Link
                                                            key={tab.id}
                                                            href={tab.url}
                                                            analyticsLabel={
                                                                tab.analyticsLabel
                                                            }
                                                            className={
                                                                linkClassName
                                                            }
                                                        >
                                                            {linkContent}
                                                        </Link>
                                                    </FeatureFlag>
                                                );
                                            })}
                                        </nav>
                                    </div>
                                </div>
                            </div>

                            {<>{props.children}</>}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}
